export const paginateData = (
  data: Record<string, string>[],
  pageNumber: number,
  rowsPerPage: number
) => {
  const start = (pageNumber - 1) * rowsPerPage
  const end = pageNumber * rowsPerPage
  if (start >= 0 && start < data.length) {
    if (end > data.length) {
      return data.slice(start, data.length)
    } else {
      return data.slice(start, end)
    }
  } else return []
}
